/*=========================================================================================
  File Name: state.js
  Description: Menus State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
    menus : [],
    currentMenu : {
      menuCategories: [],
      menuItems: []
    }
}